import { __assign } from "tslib";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import getContext from 'recompose/getContext';
import { get, partial } from 'lodash-es';
import OverlayBackground from '../components/OverlayBackground';
import { getOverlayProps, getOverlayBackgroundColour, getOverlayBackgroundAnimate, } from '../selectors/overlay';
import { isInHandoffMode } from '../selectors/handoff';
import { hideOverlay } from '../actionCreators';
import onlyIf from '../hocs/onlyIf';
import { getEventMeta } from '../utils/userTest';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    var overlay = getOverlayProps(state, isCurrentScreen);
    var animationDuration = get(overlay, 'animation.duration');
    return {
        colour: getOverlayBackgroundColour(state, isCurrentScreen),
        animate: getOverlayBackgroundAnimate(state, isCurrentScreen),
        animationDuration: animationDuration,
        key: overlay.id,
        isHandoffMode: isInHandoffMode(state),
        getEventMeta: partial(getEventMeta, state),
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    return __assign(__assign(__assign({}, ownProps), stateProps), { onClick: function (e) {
            e.stopPropagation();
            dispatch(hideOverlay('', {
                miss: stateProps.getEventMeta(e),
            }));
        } });
}
var isNotInHandoffMode = function (props) { return !props.isHandoffMode; };
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps, null, mergeProps), onlyIf(isNotInHandoffMode))(OverlayBackground);
